import { Injectable } from "@angular/core";
import { PostServiceM3 } from "../../../ConexionSQL/posts.service";
import { reserveSlots } from "@angular/core/src/render3/instructions";

@Injectable({
    providedIn: 'root'
})

export class M3Consultas {

    constructor(public PostServiceM3: PostServiceM3) {

    }

    /**
     * Obtener informacion de inventario, teniendo en cuenta los pack asociados 
     * @param sIDKatios Empresa
     * @param data Json con informacion de SKP1 (Modelo) y Ubicacion 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public async M3_GETINVENTARIOBYPACK(sIDKatios: string, data: any) {
        var resp = await this.PostServiceM3.getWithBodyM3("M3Consultas/M3_GETINVENTARIOBYPACK/" + sIDKatios, data).toPromise();
        return resp;
    }

    validarInventarioNegativoProducto(PostServiceM3: PostServiceM3, idKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3("M3/validarInventarioNegativoProducto/" + idKatios, data).subscribe(resp => {
          oFuncionOK();
        },
          error => {
            oFuncionErr(JSON.parse(error.error.Message));
          });
      }
    


}